import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits } from "viem";
import ABIUSDT from "../../utils/busdAbi.json"
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig"; // apni wagmi config ka path


const useApproveTpl = () => {
  const { address: account, isConnected, chainId } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const approveTpl = useCallback(
    async (amount) => {
      if (!isConnected || !account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        // USDT/BUSD usually 6 decimals
        const approveAmount = parseUnits(amount.toString(), 6);

        const hash = await writeContractAsync({
          address: Environment.busd,
          abi: ABIUSDT,
          functionName: "approve",
          args: [Environment.presaleContract, approveAmount],
        });

        console.log("Approval tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, {
          hash,
        });

        console.log("Approval confirmed:", receipt);

        return {
          transactionHash: hash,
          receipt,
        };
      } catch (error) {
        console.error("Approval failed:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { approveTpl };
};

export default useApproveTpl;